<template>
    <v-container>
        <v-row justify="center">
            <v-col cols="12" md="10">
                <v-card>
                    <v-card-title class="d-block py-2 text-center font-weight-bold card bg--text" style="word-break: normal">
                        <v-icon color="bg">mdi-cog</v-icon> CONFIGURACION
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" md="10">
                <v-card>
                    <v-list class="px-2" dense>
                        <v-list-item class="trunck-text">
                            <v-list-item-avatar color="card">
                                <v-icon color="bg">mdi-bell-ring</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content class="d-block font-weight-bold">
                                Notificaciones Diarias
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-switch
                                    v-model="notifications"
                                    inset
                                ></v-switch>
                            </v-list-item-action>
                        </v-list-item>
                        <v-list-item class="trunck-text">
                            <v-list-item-avatar color="card">
                                <v-icon color="bg">mdi-sync</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content class="d-block font-weight-bold">
                                Actualización Automática
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-switch
                                    v-model="sync"
                                    inset
                                ></v-switch>
                            </v-list-item-action>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-avatar color="card">
                                <v-icon color="bg">mdi-theme-light-dark</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content class="d-block font-weight-bold">
                                Tema
                            </v-list-item-content>
                            <v-list-item-action class="settings-theme-action">
                                <v-select
                                    v-model="themeMode"
                                    :items="themeOptions"
                                    item-text="text"
                                    item-value="value"
                                    :menu-props="selectMenuProps"
                                    color="primary"
                                    item-color="primary"
                                    dense
                                    filled
                                    hide-details
                                    class="settings-theme-select"
                                ></v-select>
                            </v-list-item-action>
                        </v-list-item>
                        <v-list-item class="trunck-text">
                            <v-list-item-avatar color="card">
                                <v-icon color="bg">mdi-delete</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content class="d-block font-weight-bold">
                                Borrar Cache
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn color="primary" @click="trash">Borrar</v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                    <v-card-actions class="px-5">
                        <v-spacer></v-spacer>
                        Versión 1.3.0&nbsp;&nbsp;<v-icon small color="success">mdi-check-circle</v-icon>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "Settings",
        props: [ 'country' ],
        data: () => ({
            sync: true,
            notifications: true,
            themeMode: 'system',
            themeOptions: [
                { text: 'Sistema', value: 'system' },
                { text: 'Claro', value: 'light' },
                { text: 'Oscuro', value: 'dark' },
            ],
            selectMenuProps: {
                bottom: true,
                offsetY: true,
                nudgeBottom: 4,
                maxHeight: 240,
            },
        }),
        mounted () {
            this.getData();
        },
        watch: {
            country() {
                this.getData();
            },
            sync() {
                localStorage.sync = this.sync;
                this.emitSettingsChanged();
            },
            notifications() {
                localStorage.notifications = this.notifications;
                this.applyNotificationPreference();
                this.emitSettingsChanged();
            },
            themeMode() {
                localStorage.themeMode = this.themeMode;
                this.applyThemeMode();
            }
        },
        methods: {
            getData(){
                if (localStorage.sync === 'false') {
                    this.sync = false;
                } else if (localStorage.sync === 'true') {
                    this.sync = true;
                }
                if (localStorage.notifications === 'false') {
                    this.notifications = false;
                } else if (localStorage.notifications === 'true') {
                    this.notifications = true;
                }
                if (['system', 'light', 'dark'].includes(localStorage.themeMode)) {
                    this.themeMode = localStorage.themeMode;
                }
                this.applyNotificationPreference();
                this.applyThemeMode();
            },
            applyNotificationPreference() {
                if (!this.notifications || !('Notification' in window)) {
                    return;
                }

                if (Notification.permission === 'default') {
                    Notification.requestPermission().then((permission) => {
                        if (permission !== 'granted') {
                            this.notifications = false;
                        }
                    });
                } else if (Notification.permission === 'denied') {
                    this.notifications = false;
                }
            },
            emitSettingsChanged() {
                window.dispatchEvent(new CustomEvent('dollar-settings-changed'));
            },
            applyThemeMode() {
                if (this.themeMode === 'dark') {
                    this.$vuetify.theme.dark = true;
                    return;
                }

                if (this.themeMode === 'light') {
                    this.$vuetify.theme.dark = false;
                    return;
                }

                this.$vuetify.theme.dark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            },
            trash() {
                if ('caches' in window) {
                    caches.keys().then((names) => {
                        names.forEach((name) => {
                            caches.delete(name);
                        });
                    });
                }
                localStorage.clear();
                sessionStorage.clear();
                this.notifications = true;
                this.sync = true;
                this.themeMode = 'system';
                this.applyThemeMode();
            }
        }
    }
</script>

<style scoped>
.trunck-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.settings-theme-action {
    min-width: 138px;
}
.settings-theme-select {
    max-width: 150px;
}
@media (max-width: 360px) {
    .settings-theme-action {
        min-width: 118px;
    }

    .settings-theme-select {
        max-width: 130px;
    }
}
</style>
